import "./basketballsummercampsdetails.css";
import StaticPageHeaders from "../../Components/StaticPageHeaders";
import UnlimitedBannerCom from "../../Components/InstructionsCom/UnlimitedBannerCom";
import sc_details_banner from "../../Assets/Images/SummerCampDetails/summer-ss-2026.png";
import SummerCampsBlock3 from "../../Components/SummerCampsBlock3/SummerCampsBlock3";
import SummerCampsDetailsHero from "../../Components/SummerCampsDetailsHero/SummerCampsDetailsHero";
import SEO from "../../Components/SEO";
import { NewUserContextProvider } from "../../APIContext/NewUserContext";

const SuccessStoriesBlocktwo = [
  {
    name1: "DESCRIPTION",
    description1:
      "At our camps, the morning is dedicated to skill development. We want the players to come out of camp with new knowledge of the game of basketball. We want them to be able to take skills that they learn and apply them in their games at camp and during their basketball season.",
    description2:
      "After skill work in the morning, the schedule calls for lunch. We have a hot lunch menu that is set for the week and available for purchase. You may choose to bring your own lunch as well.",
    name2: "Event Details",
    orders: "right",
  },
];

const BasketBallSummerCampsDetails = () => {
  return (
    <NewUserContextProvider>
      <>
        <SEO
          title="Basketball Summer Camps - Shootin School Basketball"
          description=""
          url="https://shootinschool.com/basketball-summer-camps"
        />

        <div className="basketballsummercampsdetails-team-page">
          <StaticPageHeaders title="BasketBall Summer Camps" />

          <div
            className="summer-c-d-hero bg-custom brightness"
            style={{ paddingTop: "30px", paddingBottom: "30px" }}
          >
            <SummerCampsDetailsHero buttonLink="/register-summer-camp" />
          </div>

          <UnlimitedBannerCom bg={sc_details_banner} brValue={1.28} />

          <div className="summerd-container">
            <div className="summerd-sss-layout">
              <div className="sss-grid" style={{ marginTop: "30px" }}>
                {SuccessStoriesBlocktwo.map((successstory, i) => (
                  <SummerCampsBlock3
                    key={i}
                    image={successstory.image}
                    name1={successstory.name1}
                    description1={successstory.description1}
                    name2={successstory.name2}
                    description2={successstory.description2}
                    order={successstory.orders}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    </NewUserContextProvider>
  );
};

export default BasketBallSummerCampsDetails;
